import Mock from 'mockjs'

// import '@/mock/login'
// import '@/mock/anva'
// import '@/mock/innodb-cluster'
// import '@/mock/appstore'
// import '@/mock/guoguan'

// 设置全局延时 没有延时的话有时候会检测不到数据变化 建议保留
Mock.setup({
  timeout: '300-600'
})
